import type { FaireProductEntity } from "../../entity_types/product";

export const p_865rtkh7t9: FaireProductEntity = {
  token: "p_865rtkh7t9",
  type: "product",
  name: "MAMAS BOY TODDLER BEANIE",
  brandToken: "b_n5qta5twp3",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/48cf435a652a98e52c5032d2242180ab37abab56f6aed8f5c0a534a88afbf26c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7caf11e2ea4e85f52db295eb104da6408446ddac272ff2bedf24017eb06f103f.jpeg",
    "https://cdn.faire.com/fastly/ac0d6f510e0fc57100a120aaa1186e2980bbee41e5f1905ec365a108a8643de2.jpeg",
    "https://cdn.faire.com/fastly/ca40b84c071ceaafff84c02930db805b4355400a09a272a53ed37a7a52800332.jpeg",
  ],
  priceDollars: 19.4,
  description:
    "The beanie every little boy needs this season. Our Mamas Boy toddler beanie is cozy, soft, and designed with everyday wear in mind. The neutral beige knit pairs effortlessly with any outfit, while the bold brown lettering adds the perfect statement. It’s warm enough for chilly days but lightweight enough for year-round style — and trust us, this one’s about to be a favorite.\n",
  tags: [],
  msrpDollars: 38.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:53.356Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
